import DownloadDocumentButton from 'document/components/button/download_document_button';
import TableCellDecimalFormatter from './columns/table_cell_decimal_formatter';
import TableCellCurrencyFormatter from './columns/table_cell_currency_formatter';
import TableCellTextFormatter from './columns/table_cell_text_formatter';

import { ProcessAPI } from 'lecom-api';

import Column from './constants/column';
import { TableCellRuleRender, TableCellRenderButton, TableCellRenderComponent } from './columns/table_cell_rule_render';

const TableCellTypesComponents = {
	'button': 'Button'
}

const TableCellRenderFactory = (props) => {
	let cellValue = props.value;
	let field;
	let maxLength;
	let digits;
	let component;
	let prefix;

	if (props.contextType === 'GRID')
		field = ProcessAPI.currentProcess().form().fields(props.gridId).fields(props.name);
	else if (props.contextType === 'SEARCHER')
		field = ProcessAPI.currentProcess().form().allFields().find(f => f.id === props.idField);

	if (field) {
		maxLength = field.maxLength() || '';
		digits = field.digits() || '';
		component = field.component() || '';
		prefix = field.prefix() || '';
	}

	if (!props.ruleRender) {
		if (props.value === '' || props.value === undefined || props.value === null || props.value === Column.EMPTY_VALUE)  {
			return <span>{Column.EMPTY_VALUE}</span>;
		}
	} else {
		if (props.ruleRender.component) {
			let { type } = props.ruleRender.component;
			if (TableCellTypesComponents[type]) {
				return <TableCellRenderComponent configComponent={props.ruleRender.component} data={{ value: cellValue, tableRowData: props.tableRowData }} />;
			}
		} else {
			cellValue = TableCellRuleRender(props.value, props.ruleRender, props.tableRowData);
		}
	}

	if (props.gridId) {
		const currentField = ProcessAPI.currentProcess().form().fields(props.gridId).fields(props.name);

		if (currentField.type() === 'AUTOCOMPLETE' || currentField.type() === 'RADIO') {
			const optionsAutoComplete = currentField.options() || [];

			if (cellValue !== undefined && cellValue !== null) {
				let findResult = {};

				if (Array.isArray(cellValue) && cellValue.length)
					findResult = optionsAutoComplete.find(opt => opt.value === cellValue[0]);
				else if (typeof cellValue === 'object' && Object.keys(cellValue).length && cellValue.value)
					findResult = optionsAutoComplete.find(opt => opt.value === cellValue.value);
				else
					findResult = optionsAutoComplete.find(opt => opt.value === cellValue);

				cellValue = typeof findResult === 'object' && Object.keys(findResult).length && findResult.name ? findResult.name : "";

				if (cellValue === null || cellValue === undefined || cellValue === "")
					cellValue = props.value;
			}
		}
	}

	switch (props.format) {
		case 'decimal':
			return <TableCellDecimalFormatter value={cellValue} maxLength={maxLength} digits={digits} component={component} prefix={prefix} />;
		case 'number':
			return <TableCellDecimalFormatter value={cellValue} maxLength={maxLength} digits={digits} component={component} prefix={prefix} />;
		case 'currency':
			return <TableCellCurrencyFormatter value={cellValue} maxLength={maxLength} digits={digits} component={component} prefix={prefix} />;
		case 'document':
			let isMobile = Lecom.api.ProcessAPI.currentProcess().isMobile();
			let pdfSigned = Lecom.stores.DocumentStore.store[props.name] ? Lecom.stores.DocumentStore.store[props.name]._template._pdfSigned : false;

			return <DownloadDocumentButton value={cellValue} name={props.name} pdfSigned={pdfSigned} isMobile={isMobile} gridId={props.gridId} tableRowData={props.tableRowData} />;
		case 'text':
			if (props.contextType === 'GRID')
				return <TableCellTextFormatter value={cellValue} mask={field.mask()} idField={field.id}/>;
			else if (props.contextType === 'SEARCHER')
				return <TableCellTextFormatter value={cellValue} mask={field.mask()} idField={field.id}/>;

			return <TableCellTextFormatter value={cellValue}/>;
		default:
			return <span className="table-cell__content" tabIndex="0">{cellValue}</span>;
	}
};

export default TableCellRenderFactory;
